<template>
  <div class="hotel-card">
    <div @click="goToHotel(hotel)"
      class="hotel-card__link block rounded overflow-hidden no-underline text-grey cursor-pointer">
      <div class="coverImage" v-lazy:background-image="hotelCover(hotel)" />
      <div class="hotel-card__content">
        <h5 class="hotel-name font-bold text-grey-darkest mb-4">{{ hotel.hotelNameLocal }}</h5>
        <div v-if="hotel.hotelNameEN && selectedLang !== 'en'" class="text-sm mb-8 text-grey-darkest font-bold">{{ hotel.hotelNameEN }}</div>
        <div class="flex items-center mb-8">
          <div class="text-xs text-grey-darker">{{ hotel.placesText }}</div>
          <span class="mx-4">|</span>
          <div class="text-grey-darker text-xs">{{ hotel.hotelType.name }}</div>
        </div>
        <div class="flex items-center">
          <div v-if="hotel.price" class="font-bold text-grey-darkest mb-8">{{ currencySign }} {{ Number(hotel.price) | currencyConvert({inputCurrency: hotel.currency, listInteger: true}) }}<i class="owl-caret-top text-grey"></i></div>
          <img v-if="hotel.tripAdvisor" :src="hotel.tripAdvisor.logo" style="width: 110px;" :alt="`${hotel.hotelName} - tripAdvisor`">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'hotelCardNewEvent',
  props: {
    hotel: {
      type: Object
    }
  },
  data () {
    return {
      MAGNIFACATION: 1.5
    }
  },
  computed: {
    ...mapGetters({
      selectedLang: 'user/selectedLang',
      currencySign: 'user/currencySign',
      selectedCurrency: 'user/selectedCurrency',
      initWidth: 'initWidth'
    }),
    hotelCardHomeImageWidth () {
      if (this.initWidth >= 1200) {
        return 280
      } else if (this.initWidth < 1200 && this.initWidth >= 992) {
        return 311
      } else if (this.initWidth < 992 && this.initWidth >= 768) {
        return 172
      } else {
        return 380
      }
    }
  },
  methods: {
    goToHotel: function (hotel) {
      window.dataLayer.push({
        event: `super-taste_${this.type}`,
        key: hotel.hotelName
      })
      window.dataLayer.push({
        event: `super-taste_${this.type}_layer2_hotel`,
        key: hotel.hotelName
      })
      const route = this.$router.resolve({
        name: 'HotelDetail',
        params: { hotelId: hotel.hotelUUID },
        query: {
          ...this.$route.query,
          externalId: hotel.hotelUUID,
          searchId: hotel.hotelUUID,
          search: hotel.hotelName,
          searchType: 'hotel'
        }
      })
      window.open(route.href, '_blank')
    },
    hotelCover: function (hotel) {
      if (hotel.image) {
        return `${hotel.image}?width=282`
      }
      return require('@/assets/images/default-room.jpg')
    }
  }
}
</script>
<style lang="sass" scoped>
@import '@/assets/style/_mixins.sass'
.hotel-card
  @apply bg-white overflow-hidden
  border-radius: 1.25rem
  &__content
    @apply p-8
  .coverImage
    @apply bg-grey-lightest bg-center bg-cover relative
    border-radius: 1.25rem
    transition-duration: .5s
    // padding-top: imageRatio(324, 192)
    aspect-ratio: 324 / 192
    background:
      position: center
      repeat: no-repeat
      size: cover
    &:hover
      transform: scale(1.05)
  .hotel-name
    @include ellipsis(1)
  .engName
    @include ellipsis(1)
</style>
